import { IDepartmentSectionInitialState } from "../../../types/permissions/departmentInterface";
import { DepartmentSectionActionTypes, DepartmentSectionActions } from "../../actionTypes/permissions/departmentSectionActionTypes";


const initialState: IDepartmentSectionInitialState = {
  departmentSectionList: {
    sections: [],
    departments: []
  },
};

export default function departmentSectionReducer(state = initialState, action: DepartmentSectionActionTypes): IDepartmentSectionInitialState {
  switch (action.type) {
    case DepartmentSectionActions.SET_DEPARTMENT_SECTION_LIST:
      return {
        ...state,
        departmentSectionList: {
          ...state.departmentSectionList,
          sections: action.payload?.sections,
          departments: action.payload?.departments
        },
      };

    default:
      return state;
  }
}
